import { Heading, Text } from 'ui-kit/typography'
import clsx from 'clsx'
import classes from './IntegrationsHero.module.scss'

export const IntegrationsHero = ({ className }: { className: string }) => {
  return (
    <section className={clsx(classes.section, className)}>
      <Heading as={'h1'} size={'xxl'} center balance className={classes.title}>
        Supported Integrations
      </Heading>
      <Text size={'lg'} center className={classes.subtitle}>
        Explore apps you can integrate with through{' '}
        <strong>Integration&nbsp;App</strong> and view their integration
        profiles for details.
      </Text>
    </section>
  )
}
